module.exports = __webpack_public_path__ + "static/media/icon-failed-red.97ffe79c.svg";